<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :linkback="linkback" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Nome</label>
                        <b-form-input v-model="filtroConfigurazioneAttivita.nomeAttivita" type="search" id="codice" placeholder="Inserire nome..."></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Area</label>
                        <b-form-select id="inline-form-custom-select-pref" v-model="filtroConfigurazioneAttivita.idArea" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="id" text-field="nome" :options="areaOptions"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Diario</label>
                        <b-form-select id="inline-form-custom-select-pref" v-model="filtroConfigurazioneAttivita.idDiario" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="id" text-field="nome" :options="diarioOptions"></b-form-select>
                    </b-col>
                </b-row>
                <b-row style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-configurazione-attivita-list-component ref="RsaConfigurazioneAttivitaListComponent" @afterLoadData="onAfterLoadData"></rsa-configurazione-attivita-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazioneAttivitaListComponent from "../components/RsaConfigurazioneAttivitaListComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneAttivitaListComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            filtroConfigurazioneAttivita: { nomeAttivita: null, idDiario: null, idArea: null },
            btnNewVisible: true,
            btnBackVisible: true,
            btnConfigurazioniVisible: true,
            linkback: "/home",
            pathResource: "/rsaattivita",
            pathResourceAree: "/rsaaree",
            pathResourceDiari: "/rsadiari",
            linkConfigurazioni: "/configurazioni",
            linkedit: "/rsaconfigurazioneattivita",
            showModalLoading: false,
            listKey: 0,
            diarioOptions: [],
            areaOptions: [],
        };
    },
    mounted() {
        let me = this;
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroConfigurazioneAttivita"]) {
            me.filtroConfigurazioneAttivita = JSON.parse(sessionStorage["filtroConfigurazioneAttivita"]);
        }
        me.loadData();
        me.loadAree();
        me.loadDiari();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.RsaConfigurazioneAttivitaListComponent.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onReset() {
            let me = this;
            me.filtroConfigurazioneAttivita = { nomeAttivita: null, idDiario: null, idArea: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneAttivita"] = JSON.stringify(me.filtroConfigurazioneAttivita);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneAttivita"] = JSON.stringify(me.filtroConfigurazioneAttivita);
            me.loadData();
        },
        loadAree() {
            let me = this;
            me.loadDataResources(me.pathResourceAree, {}, me.resultResponseAree, me.resultErrorAree);
        },
        resultResponseAree(response) {
            let me = this;
            me.areaOptions = response.data.data.list;
            me.areaOptions.unshift({ value: null, nome: "- Seleziona Valore -" });
        },
        resultErrorAree(error) {
            console.log(error.response.messaggio);
            let messaggio = error.response.messaggio ? error.response.messaggio : "Errore caricamento Aree";
            this.$bvToast.toast(messaggio, {
                title: this.titleModal,
                variant: "danger",
                autoHideDelay: 1000,
            });
        },
        loadDiari() {
            let me = this;
            me.loadDataResources(me.pathResourceDiari, {}, me.resultResponseDiari, me.resultErrorDiari);
        },

        resultResponseDiari(response) {
            let me = this;
            me.diarioOptions = response.data.data.list;
            me.diarioOptions.unshift({ value: null, nome: "- Seleziona Valore -" });
        },
        resultErrorDiari(error) {
            console.log(error.response.messaggio);
            let messaggio = error.response.messaggio ? error.response.messaggio : "Errore caricamento Diari";
            this.$bvToast.toast(messaggio, {
                title: this.titleModal,
                variant: "danger",
                autoHideDelay: 1000,
            });
        },
    },
};
</script>

<style></style>
